import cx from "classnames";
import { ExclamationCircleIcon } from "@heroicons/react/20/solid";

const Textarea = ({ id, rows, placeholder, className, input, onChange = () => {}, meta }) => (
    <div className="relative">
        <textarea
            onChange={onChange}
            {...input}
            className={cx(
                "group-[.has-error]:input-error",
                "block w-full rounded-md border-gray-300 text-sm shadow-sm focus:border-orange-500 focus:ring-orange-500",
                className
            )}
            id={id}
            rows={rows}
            placeholder={placeholder}
        />
        <div className="pointer-events-none absolute inset-y-0 right-0 hidden  items-end pb-2 pr-3 group-[.has-error]:flex">
            <ExclamationCircleIcon className="h-5 w-5 text-red-500" aria-hidden="true" />
        </div>
    </div>
);
export default Textarea;
